import React from 'react';

function RequiredFormField() {
    return (
        <span className='text-red-600'>
            {" * "}
        </span>
    );
}

export default RequiredFormField;